module.exports = __webpack_public_path__ + "47d4a4159c10b48372d3ce34c075cab0.png";